export class CurrencyUtils {
    public static formatCurrencyValue(value: number, preferWithoutFraction: boolean = true): string {
        const fixed = value.toFixed(2);
        const [wholeNumber, fraction] = fixed.split('.');
        const formattedWholeNumber: string = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

        if (preferWithoutFraction && Number.parseInt(fraction, 10) === 0) {
            return formattedWholeNumber;
        }

        return `${formattedWholeNumber},${fraction}`;
    }
}
